import { CircularProgress, Grid, Hidden } from '@material-ui/core/';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as deliveryActions from '~/store/legacy/actions/deliveryActions';
import * as mealActions from '~/store/legacy/actions/mealActions.js';
import { setUserServiceType } from '~/store/legacy/actions/userActions.js';
import { ssrApi } from '~/api/ssrApi';
import AddressAndServiceType from '~/components/AddressAndServiceType.jsx';
import AppToolBar from '~/components/AppToolBar.jsx';
import DeliveryRestaurantMenu from '~/components/menu/DeliveryRestaurantMenu';
import Page from '~/components/Page';
import SearchBar from '~/components/SearchBar.jsx';
import { SERVICE_TYPE } from '~/constant.js';
import { selectDeliveryGroupByRestaurantId } from '~/store/legacy/selector/deliverySelectors.js';
import { extract } from '~/utils/jsonApi.js';

function DeliveryMenu(props) {
  const router = useRouter();
  const dispatch = useDispatch();
  const deliveryZoneBlackedOut = props.deliveryZoneBlackedOut;

  const [currentRestaurant, setCurrentRestaurant] = useState(() => {
    let currentRestaurant = props.meals[0].relationships.restaurant.data;
    currentRestaurant = Object.assign({}, currentRestaurant, {
      attributes: Object.assign({}, currentRestaurant.attributes, {
        deliveryZoneBlackedOut: !!deliveryZoneBlackedOut
      })
    });
    return currentRestaurant;
  });
  // Server Side Render has pass us some data as props
  // put it in redux so everybody can use it
  useEffect(() => {
    dispatch(setUserServiceType({ serviceType: SERVICE_TYPE.DELIVERY }));
    dispatch({
      type: mealActions.mealActionTypes.loadMealsByRestaurantsSuccess,
      meals: props.meals,
      serviceType: SERVICE_TYPE.DELIVERY,
    });
    dispatch({
      type: deliveryActions.deliveryActionTypes.fetchDeliveryGroupsSuccess,
      deliveryGroups: props.deliveryGroups,
    });
  }, []);

  useEffect(() => {
    let currentRestaurant = props.meals[0].relationships.restaurant.data;
    currentRestaurant = Object.assign({}, currentRestaurant, {
      attributes: Object.assign({}, currentRestaurant.attributes, {
        deliveryZoneBlackedOut: !!deliveryZoneBlackedOut
      })
    });
    setCurrentRestaurant(currentRestaurant);

  }, [props.meals[0].relationships.restaurant.data]);

  // eslint-disable-next-line no-unused-vars
  const [restaurantName, restaurantId, mealId] = router.query.params;
  const deliveryGroup = useSelector(selectDeliveryGroupByRestaurantId(restaurantId));
  const restaurantIds = deliveryGroup
    ? deliveryGroup.relationships.restaurants.data.map((restaurant) => restaurant.id)
    : [restaurantId];

  // The secret is, restaurant info only comes attached to meal items
  // so to show the tabs, we need to load all their meals.
  useEffect(() => {
    dispatch(mealActions.loadMealsByRestaurantIds({ restaurantIds }));
  }, [deliveryGroup]);

  return (
    <Page name='menu'>
      <AppToolBar>
        <Grid container alignItems='center'>
          <Grid item style={{ flexGrow: 1 }}>
            <Hidden smDown>
              <AddressAndServiceType />
            </Hidden>
          </Grid>
          <Grid item>
            <SearchBar searchOn={restaurantId} />
          </Grid>
        </Grid>
      </AppToolBar>
      <Hidden mdUp>
        <div style={{ marginTop: 20 }}>
          <AddressAndServiceType />
        </div>
      </Hidden>
      {!currentRestaurant && (
        <Grid container justify='center'>
          <CircularProgress />
        </Grid>
      )}
      {currentRestaurant && (
        <DeliveryRestaurantMenu restaurant={currentRestaurant} mealId={mealId} />
      )}
    </Page>
  );
}

export async function getServerSideProps(context) {
  const restaurantIds = [context.query.params[1]];
  const [addressId, geoLocation] = getLocation(context);
  const [meals, deliveryGroupJson] = await Promise.all([
    ssrApi.meals.fetchMeals(restaurantIds),
    ssrApi.delivery.fetchDeliveryGroups(addressId, geoLocation),
  ]);
  const extractedMeals = extract(meals.data, 'mealInstance');
  if (!extractedMeals) {
    return {
      notFound: true,
    };
  }
  let { meta: { delivery_zone_blacked_out } } = deliveryGroupJson.data;
  const deliveryGroups = extract(deliveryGroupJson.data, 'deliveryGroup') || [];
  return {
    props: {
      meals: extractedMeals,
      deliveryGroups,
      deliveryZoneBlackedOut: !!delivery_zone_blacked_out,
    },
  };
}

function getLocation(context) {
  let addressId;
  let geoLocation;

  // get info from context if available
  const userFromServer = context.req?.serverData?.user;
  if (userFromServer?.addressId) {
    addressId = userFromServer.addressId;
  }
  if (userFromServer?.address?.latitude && userFromServer?.address?.longitude) {
    geoLocation = {
      lat: userFromServer.address.latitude,
      lng: userFromServer.address.longitude,
    };
  }
  // if not, check the cookies
  if (!addressId || !geoLocation) {
    const rawCookies = context?.req?.headers?.cookie;
    const cookies = !rawCookies
      ? {}
      : rawCookies.split('; ').reduce((acc, cookie) => {
        const [key, value] = cookie.split('=');
        acc[key] = value;
        return acc;
      }, {});
    if (!addressId) {
      addressId = cookies.address_id || null;
    }
    if (!geoLocation && cookies.geo_location) {
      let gl;
      try {
        gl = JSON.parse(decodeURIComponent(cookies.geo_location));
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
      }
      geoLocation = gl || null;
    }
  }
  return [addressId, geoLocation];
}

export default DeliveryMenu;
